import { PostModel } from '../../../data-layer/posts/types';
import { ClickoutTarget } from '../../../ui/posts/types';

const getGridClickout = (post: PostModel) =>
    post.clickouts?.find((clickout) => clickout.target === ClickoutTarget.GRID);

/** Общий для href карточки и обработчика клика — они обязаны вести в одно место */
export const getPostGridLink = (post: PostModel) => {
    if (post.postType === 'collection') {
        return { href: `/collections/${post.collectionData?.id}`, isExternal: false };
    }

    const gridClickout = getGridClickout(post);

    return gridClickout
        ? { href: gridClickout.url, isExternal: true }
        : { href: post.url, isExternal: false };
};
